import React from "react";
// import {useSelector} from 'react-redux';

import Toolbar from "../../components/Navigation/Toolbar/Toolbar";
import "./Layout.css";

const Layout = (props) => {

    //const isAuth = useSelector(state => state.auth.token !== null)

    return (
        <div className="Layout">
            <Toolbar/>
            <div className="Content">{props.children}</div>
        </div>
    );
};


export default Layout;
